<template>
  <el-cascader
    class="base-cascader"
    :class="[`base-cascader-${color}`]"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'BaseCascader',
  props: {
    // 决定于边框的颜色
    color: {
      type: String,
      default: 'blue',
    },
  },
}
</script>

<style lang="less" scoped>
.base-cascader {
  &.base-cascader-blue {
    /deep/ .el-input__inner {
      border-color: #e1e1e1;
      height: 36px;
      &[disabled] {
        color: #606266;
        border-color: #e1e1e1;
      }
      &:focus {
        border-color: #3a6bd5;
      }
    }
  }
}
</style>
